import { produce } from "immer";
import * as WatchlistConstants from "./WatchlistConstants";
import * as CommonConstants from "Common/constants/commonConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  fetchWatchlistStatus: CommonConstants.STATUS_SUCCESS, // SUCCESS -> PENDING -> FAILED | SUCCESS
  fetchWatchlistErrMsg: "",
  watchlist: [],
  watchlistActionStatus: CommonConstants.STATUS_SUCCESS, // STATUS_SUCCESS -> STATUS_PENDING -> STATUS_FAILED
  removeWatchlistAccessDenied: false,
};

export default function WatchlistReducer(state = initialState, action) {
  switch (action.type) {
    /*
     * updation of state according to the fetch watchlist actions dispatched
     */
    case WatchlistConstants.FETCH_WATCHLIST_REQUEST: {
      const newState = {
        ...state,
        fetchWatchlistStatus: CommonConstants.STATUS_PENDING, // SUCCESS -> PENDING -> FAILED | SUCCESS
        fetchWatchlistErrMsg: "",
        watchlist: [],
      };
      return assign({}, state, newState);
    }
    case WatchlistConstants.FETCH_WATCHLIST_SUCCESS: {
      const newState = {
        ...state,
        fetchWatchlistStatus: CommonConstants.STATUS_SUCCESS, // SUCCESS -> PENDING -> FAILED | SUCCESS
        fetchWatchlistErrMsg: "",
        watchlist: [...action.payload],
      };
      return assign({}, state, newState);
    }
    case WatchlistConstants.FETCH_WATCHLIST_ERROR: {
      const newState = {
        ...state,
        fetchWatchlistStatus: CommonConstants.STATUS_FAILED, // SUCCESS -> PENDING -> FAILED | SUCCESS
        fetchWatchlistErrMsg:
          action.payload?.debugMessage || CommonConstants.GENERIC_ERROR_MESSAGE,
        watchlist: [],
      };
      return assign({}, state, newState);
    }
    case WatchlistConstants.REMOVE_WATCHLIST_REQUEST:
      return assign({}, state, {
        watchlistActionStatus: CommonConstants.STATUS_PENDING,
      });
    case WatchlistConstants.REMOVE_WATCHLIST_SUCCESS: {
      const newState = produce(state, (draft) => {
        draft.watchlistActionStatus = CommonConstants.STATUS_SUCCESS;
        const itemIndex = draft.watchlist.findIndex(
          (item) => item.instance === action.payload.instanceId
        );

        if (itemIndex !== -1) {
          draft.watchlist = [
            ...draft.watchlist.slice(0, itemIndex),
            ...draft.watchlist.slice(itemIndex + 1),
          ];
        }
      });

      return assign({}, state, newState);
    }
    case WatchlistConstants.REMOVE_WATCHLIST_ERROR:
      return assign({}, state, {
        watchlistActionStatus: CommonConstants.STATUS_FAILED,
      });
    case WatchlistConstants.REMOVE_WATCHLIST_ACCESS_DENIED:
      return assign({}, state, {
        watchlistActionStatus: CommonConstants.STATUS_SUCCESS, // setting it to STATUS_FAILED will cause the ErrorComponent popup to show
        removeWatchlistAccessDenied: action.payload,
      });
    case WatchlistConstants.REMOVE_WATCHLIST_RESET_STATUS:
      return assign({}, state, {
        watchlistActionStatus: CommonConstants.STATUS_SUCCESS,
      });
    default:
      return state;
  }
}
